import { Injectable, TemplateRef } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { UnsavedChangesModalComponent } from '@shared/components/unsaved-changes-modal/unsaved-changes-modal.component';

export interface UnsavedChangesOptions {
  titleKey?: string;
  messageKey?: string;
  messageTemplate?: TemplateRef<any>;
  cancelKey?: string;
  confirmKey?: string;
  windowClass?: string;
}

@Injectable({ providedIn: 'root' })
export class UnsavedChangesService {
  constructor(private modalService: NgbModal) {}

  confirm(options: UnsavedChangesOptions = {}): Promise<boolean> {
    const { windowClass, ...inputs } = options;
    const modalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: true,
      centered: true,
      windowClass,
    };
    const ref = this.modalService.open(UnsavedChangesModalComponent, modalOptions);
    Object.assign(ref.componentInstance, inputs);

    return ref.result.then(
      (result) => result === true,
      () => false,
    );
  }
}
